<div [formGroup]="ladingStatusForm" class="lading-status-cell-editor">
    <mat-form-field appearance="fill">
      <mat-label>Status</mat-label>
      <mat-select formControlName="status">
        <mat-option *ngFor="let status of lading_status_options" [value]="status">
          {{ status }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  
    <!-- Date and Time Fields -->
    <div *ngIf="showDateAndTime">
      <mat-form-field appearance="fill">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
  
      <mat-form-field appearance="fill">
        <mat-label>Time</mat-label>
        <input matInput type="time" formControlName="time">
      </mat-form-field>
  
      <mat-form-field appearance="fill">
        <mat-label>Timezone</mat-label>
        <mat-select formControlName="timezone">
          <mat-option *ngFor="let zone of setAutoselectedTimezone()" [value]="zone">
            {{ formatTimezoneString(zone) }}, {{ timezone_regions[zone] }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  
    <!-- Action Buttons -->
    <div class="actions">
      <button mat-stroked-button (click)="onCancel()">Cancel</button>
      <button mat-flat-button color="primary" (click)="onSave()" [disabled]="ladingStatusForm.invalid">Save</button>
    </div>
  </div>